import * as THREE from 'three';

export const getHorizontalRotationBetweenPoints = (point1, point2) => {
  const vOX = new THREE.Vector3(0, 0, 1); // OX axis

  const v1 = new THREE.Vector3(point1.data.position.x, point1.data.position.y, point1.data.position.z);
  const v2 = new THREE.Vector3(point2.data.position.x, point2.data.position.y, point2.data.position.z);

  const direction = new THREE.Vector3();
  direction.subVectors(v1, v2);
  direction.y = 0;
  direction.normalize();
  vOX.normalize();

  const dot = direction.dot(vOX);
  const cross = new THREE.Vector3().crossVectors(vOX, direction).y;

  let horizontalRotation = Math.acos(dot);

  if (cross < 0) {
    horizontalRotation = -horizontalRotation;
  }

  return THREE.MathUtils.radToDeg(horizontalRotation);
};
